import React from "react";
import "../styles/Contact.css";

import contactData from "../data/contactData";

const Contact = () => {
  const {
    phoneNumber,
    whatsappMessage,
    email,
    instagram,
    facebook,
    location,
    hours,
    contacts,
  } = contactData;

  // Helper to get data for each contact type
  const getData = (type) => {
    switch (type) {
      case "phone":
      case "whatsapp":
        return phoneNumber;
      case "email":
        return email;
      case "instagram":
        return instagram;
      case "facebook":
        return facebook;
      case "location":
        return location;
      case "hours":
        return hours;
      default:
        return "";
    }
  };

  return (
    <div className="contact-page">
      <h2>Contact Us</h2>
      <p className="contact-intro">
        We'd love to hear from you. Reach out to place orders or ask questions.
      </p>

      <div className="contact-box">
        <address className="contact-info" aria-label="Contact information">
          <h3>Get in Touch</h3>
          <ul>
            {contacts.map(
              (
                {
                  type,
                  href,
                  display,
                  icon: Icon,
                  ariaLabel,
                  isTextOnly,
                  iconClassName,
                  extraParams,
                },
                idx
              ) => {
                const data = getData(type);
                const extraArgs =
                  extraParams?.map((param) => contactData[param]) || [];

                const hrefValue = href
                  ? href(data, ...extraArgs)
                  : undefined;
                const displayValue = display ? display(data) : data;
                const ariaLabelValue = ariaLabel
                  ? ariaLabel(data)
                  : undefined;

                return (
                  <li key={idx}>
                    {isTextOnly ? (
                      <>
                        <Icon className="icon" />
                        {displayValue}
                      </>
                    ) : (
                      <a
                        href={hrefValue}
                        className="contact-link"
                        aria-label={ariaLabelValue}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Icon className={`icon ${iconClassName || ""}`} />
                        {displayValue}
                      </a>
                    )}
                  </li>
                );
              }
            )}
          </ul>
        </address>

        <div className="contact-form">
          <h3>Send a Message</h3>
          <form onSubmit={(e) => e.preventDefault()} aria-label="Contact form">
            <label htmlFor="name" className="sr-only">
              Your Name
            </label>
            <input type="text" id="name" name="name" placeholder="Your Name" required />

            <label htmlFor="email" className="sr-only">
              Your Email
            </label>
            <input type="email" id="email" name="email" placeholder="Your Email" required />

            <label htmlFor="message" className="sr-only">
              Your Message
            </label>
            <textarea
              id="message"
              name="message"
              rows="5"
              placeholder="Your Message"
              required
            />

            <button className="btn btn-large" type="submit">Send Message</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
